exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-cant-conceptos {\r\n\t/*width: 25px;\r\n    height: 25px;\r\n    text-align: center;\r\n    border-radius: 20px;\r\n    background-color: #29a78f;\r\n    color: white;*/\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    padding: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/directives/conceptos/conceptos.component.css
// module id = ../../../../../src/app/directives/conceptos/conceptos.component.css
// module chunks = main